var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpinnerLoading = function SvgSpinnerLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.875C10.3452 1.875 10.625 2.15482 10.625 2.5V5C10.625 5.34518 10.3452 5.625 10 5.625C9.65482 5.625 9.375 5.34518 9.375 5V2.5C9.375 2.15482 9.65482 1.875 10 1.875Z",
    fill: "#FF8300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7466 4.25337C15.9907 4.49745 15.9907 4.89318 15.7466 5.13725L13.981 6.90288C13.7369 7.14696 13.3412 7.14696 13.0971 6.90288C12.853 6.6588 12.853 6.26307 13.0971 6.019L14.8627 4.25337C15.1068 4.00929 15.5026 4.00929 15.7466 4.25337Z",
    fill: "#FF8300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 10C14.375 9.65482 14.6548 9.375 15 9.375H17.5C17.8452 9.375 18.125 9.65482 18.125 10C18.125 10.3452 17.8452 10.625 17.5 10.625H15C14.6548 10.625 14.375 10.3452 14.375 10Z",
    fill: "#FF8300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0971 13.0971C13.3412 12.853 13.7369 12.853 13.981 13.0971L15.7466 14.8627C15.9907 15.1068 15.9907 15.5026 15.7466 15.7466C15.5026 15.9907 15.1068 15.9907 14.8627 15.7466L13.0971 13.981C12.853 13.7369 12.853 13.3412 13.0971 13.0971Z",
    fill: "#FF8300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.375C10.3452 14.375 10.625 14.6548 10.625 15V17.5C10.625 17.8452 10.3452 18.125 10 18.125C9.65482 18.125 9.375 17.8452 9.375 17.5V15C9.375 14.6548 9.65482 14.375 10 14.375Z",
    fill: "#FF8300"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90288 13.0971C7.14696 13.3412 7.14696 13.7369 6.90288 13.981L5.13725 15.7466C4.89318 15.9907 4.49745 15.9907 4.25337 15.7466C4.00929 15.5026 4.00929 15.1068 4.25337 14.8627L6.019 13.0971C6.26307 12.853 6.6588 12.853 6.90288 13.0971Z",
    fill: "#FF8300"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 10C1.875 9.65482 2.15482 9.375 2.5 9.375H5C5.34518 9.375 5.625 9.65482 5.625 10C5.625 10.3452 5.34518 10.625 5 10.625H2.5C2.15482 10.625 1.875 10.3452 1.875 10Z",
    fill: "#FF8300"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25337 4.25337C4.49745 4.00929 4.89318 4.00929 5.13725 4.25337L6.90288 6.019C7.14696 6.26307 7.14696 6.6588 6.90288 6.90288C6.6588 7.14696 6.26307 7.14696 6.019 6.90288L4.25337 5.13725C4.00929 4.89318 4.00929 4.49745 4.25337 4.25337Z",
    fill: "#FF8300"
  })));
};
export default SvgSpinnerLoading;